<template>
  <section id="location" class="sections sections--bg">
    <v-container>
      <v-row class="mb-10">
        <v-col cols="12" sm="4">
          <div class="sections-box">
            <div class="sections--border">
              <span class="sections--title">Peta Sebaran</span>
              <h2 class="sections--menu">SONGKET DI INDONESIA</h2>
            </div>
          </div>
        </v-col>
        <v-col>
          Songket merupakan bagian dari kebudayaan Nusantara yang sudah lama ada dan berkembang menyebar ke hampir seluruh wilayah Indonesia.
        </v-col>
      </v-row>
      <v-row>
        <v-col class="locations--card mb-10"></v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
